import { SaveOutlined } from '@ant-design/icons';
import { Button, type FormInstance } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  EAbilityActions,
  type EAbilitySubjects,
} from '@client/hooks/useAbilities';

import type { MongoAbility } from '@casl/ability';
import type { ButtonColorType, ButtonVariantType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

type TSaveButton = {
  formRef?: FormInstance<any>;
  loading?: boolean;
  className?: string;
  isEdit?: boolean;
  disabled?: boolean;
  danger?: boolean;
  size?: SizeType;
  color?: ButtonColorType;
  icon?: React.ReactNode;
  variant?: ButtonVariantType;
  htmlType?: 'submit' | 'reset' | 'button';
  onClick?: () => void;
  ableFor: {
    ability: MongoAbility;
    subject: string | keyof typeof EAbilitySubjects;
  };
};

export const SaveButton: React.FC<TSaveButton> = (props) => {
  const { t } = useTranslation();

  const {
    formRef,
    loading,
    className,
    isEdit,
    disabled,
    size = 'small',
    color = 'primary',
    icon = <SaveOutlined />,
    htmlType = 'submit',
    variant = 'solid',
    onClick,
    ableFor,
    danger = false,
  } = props;

  const handleFormSubmission = (): void => {
    if (formRef && htmlType === 'submit') {
      formRef?.submit();
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleFormSubmission();
    onClick?.();
  };

  const label = isEdit ? t('actions.update') : t('actions.save');

  const btnSave = (
    <Button
      size={size}
      variant={variant}
      htmlType={htmlType}
      className={className}
      disabled={disabled}
      loading={loading}
      icon={icon}
      danger={danger}
      onClick={handleClick}
      color={color}
    >
      {label}
    </Button>
  );

  const action: EAbilityActions.CREATE | EAbilityActions.UPDATE = isEdit
    ? EAbilityActions.UPDATE
    : EAbilityActions.CREATE;

  return ableFor.ability.can(action, ableFor.subject) ? btnSave : null;
};
